<template>
    <div class="content-wrap">
        <!--顶部图片-->
        <img  :src="banner.picurl" class="top-img" alt="加载失败" />
        <div class="card sub-card">
            <div class="title" v-if="currentType != 3">我的评价</div>
            <p class="finish-con">
                <!-- {{ "非常感谢您对A.O.史密斯的信任和支持，您的" + processName + "已经全部安装并调试完毕，现场验收合格还请您验收。"}}。 -->
                非常感谢您对A.O.史密斯的信任和支持，您的冷暖风水系统产品已经全部安装并调试完毕，监理已依据《冷暖风水系统质量管理标准》，对现场进行监理验收，
                均已全部合格，还请您验收！
            </p>
            <div class="finish-btn-wrap flc">
                <img class="finish-btn" :src="isAgree ? checkSelect : checkCommon" @click="isAgree = !isAgree" />
                <div class="finish-btn-text">我已阅读并确认验收合格</div>
            </div>
        </div>
        <!--block2-->
        <div class="card">
            <div class="card-title fls">
                <div class="card-title-block"></div>
                <p class="card-title-text">{{"对本" + processName + "是否满意?"}}</p>
            </div>
            <!--评星-->
            <div class="star-wrap">
                <div class="star-item fls" v-for="(item, index) in evaStarList" :key="index">
                    <div class="star-item-text">{{ item.title }}</div>
                    <div class="star-item-img flc">
                        <img v-for="(star, index2) in item.star" :key="index2" :src="star ? starSelect : starCommon" class="star" alt="" @click="lightStar(index, index2)" />
                    </div>
                </div>
            </div>
            <textarea class="advice-text" v-model="sContent" v-if="currentType == 1" name="" id="" cols="30" rows="10" placeholder="您好，分享您的销售体验、施工体验等给我们更多建议，以便为您更好的服务。"></textarea>
            <div class="content" v-else>{{content}}</div>

           <div class="recording-btn flc" @click="clickRecord" v-if="currentType == 1">
                <img src="@/assets/images/user/house/record-icon.png" alt="">
                <div>点击录制评价语音</div>
               <div>{{status == 'start' ? '点击结束录制':'点击录制评价语音'}}</div>
            </div>
            <div class="recording-btn flc" style="margin-top:20px;" @click.stop="audioClick" v-else>
                <audio ref="audioRef" class="audio-ref" :src="sAudioUrl" />
                <img src="@/assets/images/user/house/record-icon.png" alt="">
                <div>查看语音评价</div>
            </div>
            
            <div class="addContent" v-if="currentType == 3 ">
                <div>追加评价</div>
                <div>{{addContent}}</div>
                <div class="imgbox">
                    <div class="img-div" v-for="(item,index) in arrLocalBase64" :key="index">
                        <img v-if="item.type == 'image'" @click="handleImagePreview(arrLocalBase64,index)" :src="item.pic" alt="" class="img">
                        <video v-else :src="item.pic" @click="playVideo(item.pic)" class="img"></video>
                    </div>
                </div>
            </div>
            <div class="addContent2" v-if="true">
                <div>追加评价</div>
                <input class="input" type="text" v-model="addContent" placeholder='这里输入追加评价'>
                <div class="imgbox">
                    <div class="img-div" v-for="(item,index) in arrMedia" :key="index">
                        <img @click="deleImg(index)" class="delete-image" src="@/assets/images/image-delete.png" />
                        <img v-if="item.type == 'image'" @click="handleImagePreview(arrMedia,index)" :src="item.url" alt="" class="img">
                        <video v-else @click="playVideo(item.url)" :src="item.url" alt="" class="img"></video>
                    </div>
                    <div class="img-div">
                        <img v-show="this.nMediaCount > this.arrMedia.length" @click="choiceImg" src="@/assets/images/user/house/save1.png" alt="" class="img">
                    </div>
                    <input @change="imageToBase64" v-show="false" ref="filElem" type="file" id="input" />
                    <div id="in-box" style="display:none"></div>
                </div>
                <div @click="reSubmit" class="addContentBtn">
                    追加评价
                </div>
            </div>
        </div>
        <!--提交按钮-->
        <div @click="submit" class="sub-btn" v-if="currentType == 1">确认验收</div>
         <!-- <van-popup v-model="BshowToast" custom-style="padding:10px;" @close='handleClose'>
            <div style="padding:10px;">
            <div style="font-weight: 800;">提示</div>
            <div style="margin-top:10px;">已结束录制，您可选择重新录制与试听录音</div>
            <div style="margin-top:10px;text-align: center;">
                <van-button size="small" square type="primary" @click="recordAgin">重新录制</van-button>
                <van-button style="margin-left: 10px;" size="small" square type="primary" @click="Audition">{{AuditionStatus}}</van-button>
            </div>
            </div>
            
        </van-popup>
        <van-popup class="pop" v-model="isVideoShow" closeable position="bottom" :style="{ height: '100%'  }">
            <div class="wrapper" v-if="isVideoShow">
                <video :src="sVideoPath" controls></video>
            </div>
        </van-popup> -->
        <!-- 勾选弹窗 -->
        <div class="tips_read" v-if="bTipsRead" @click.stop="bTipsRead = !bTipsRead">
            <div class="tips_read_content">
                <div>请勾选已阅并确认验收合格</div>
                <div class="text_read">如疑问，请点击“有疑问”联系项目经理，谢谢</div>
                <div class="read_btn" @click.stop="bTipsRead = !bTipsRead,isAgree = true">确认</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getWxSingleConfig } from "@/js/wx.js";
import { sendSeriveId } from "@/js/finish.js";
import { ImagePreview } from "vant";
import net from "../../../js/evaluate";
import { log } from '@antv/g2plot/lib/utils';
//import { fetchVerifyAuthForB } from "@/libsV2/havc.js";
let OSS = require("ali-oss");
export default {
    // 竣工评价
    name: "finishEva",

    data() {
        return {
            bTipsRead:false,
            isVideoShow: false, //是否显显示视频播放控件
            oss: {}, //oss相关配置
            upLoadFiles: [], //传给后台的数据
            arrMedia: [], //本地展示的数据
            nMediaCount: 6, //上传的多媒体数量限制
            addContent: "", //追加评价
            topPic: "",
            processName: this.$route.query.processName,
            content: "",
            company_id: this.$route.query.company_id, //公司id
            contract_id: this.$route.query.contract_id, //合同id
            topic_id: this.$route.query.topic_id, //项目id
            sProjectUuid: this.$route.query.project_uuid,
            isAgree: false,
            checkCommon: require("@/assets/images/user/house/check-common.png"),
            checkSelect: require("@/assets/images/user/house/check-select.png"),
            starCommon: require("@/assets/images/user/house/star-common.png"),
            starSelect: require("@/assets/images/user/house/star-select.png"),
            evaStarList: [
                {
                    title: "销售体验满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "系统设计满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "安装人员满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "系统施工满意度",
                    star: [false, false, false, false, false],
                },
                {
                    title: "服务效率满意度",
                    star: [false, false, false, false, false],
                },
            ],
            status: "close",
            localId: "",
            BshowToast: false,
            AuditionStatus: "试听录音", //控制试听的播放和暂停
            currentType: 1,
            voiceData: "",
            sVoiceUrl: "",
            sContent: "",
            sVideoPath: "",
            sAudioUrl: "",
        };
    },
    created() {
        //console.log("-----------------")
        //console.log(this.$userHouse.state.usreHouserList)
        $init(() => {
            this.$store.dispatch("banner/getData", 12);
            getWxSingleConfig();
            net.getList({ project_uuid: this.sProjectUuid }).then((res) => {
                if (res.data.data.result.completed.length == 0) {
                    this.currentType = 1;
                } else if (res.data.data.result.completedTo.length == 0) {
                    this.isAgree = true;
                    this.currentType = 2;
                } else {
                    this.isAgree = true;
                    this.currentType = 3;
                }
                //console.log(this.currentType)
                var object = res.data.data.result.completed;
                this.sAudioUrl=object.voice
                this.content = object.content;
                this.arrLocalBase64 = res.data.data.result.completedTo.pic;
                this.addContent = res.data.data.result.completedTo.content;
                this.evaStarList.forEach((item, index) => {
                    switch (index) {
                        case 0:
                            item.star = this.getStar(object.sale_score);
                            break;
                        case 1:
                            item.star = this.getStar(object.sign_score);
                            break;
                        case 2:
                            item.star = this.getStar(object.work_score);
                            break;
                        case 3:
                            item.star = this.getStar(object.delivery_score);
                            break;
                        case 4:
                            item.star = this.getStar(object.service_score);
                            break;
                    }
                });
            });
        });
    },

    computed: {
        banner() {
            return this.$store.state.banner.ending;
        },
    },
    methods: {
        deleImg(index) {
            this.arrMedia.splice(index, 1);
            this.upLoadFiles.splice(index, 1);
        },

        imageToBase64() {
            var _this = this;
            const inputFile = this.$refs.filElem.files[0];
            this.$refs.filElem.value = null

            this.inputFile = inputFile;
            console.log(this.inputFile);
            if (this.inputFile) {
                
                let inputFile = this.inputFile;
                if (
                    inputFile.type !== "image/jpeg" &&
                    inputFile.type !== "image/png" &&
                    inputFile.type !== "image/jpg" &&
                    inputFile.type !== "video/mp4"
                ) {
                    alert("上传图片或者视频！", "warning");
                    return;
                }
                if (inputFile.size > 50 * 1024 * 1024) {
                    alert("请上传小于 50M 的图片 ！", "warning");
                    return;
                }
                this.uploadImg(inputFile);
            } else {
                return;
            }
        },
        uploadImg(inputFile) {
            var data = inputFile.name;

            let flieArr = data.split(".");
            let suffix = flieArr[flieArr.length - 1];
            let uploadData = {
                ext: suffix,
            };
            // 获取oss配置
            net.ossconfig(uploadData).then((res) => {
                let uploadOss = res.data.data.result;
                let client = new OSS({
                    region: uploadOss.sts.region,
                    bucket: uploadOss.sts.bucket,
                    accessKeyId: uploadOss.sts.access_key_id,
                    accessKeySecret: uploadOss.sts.access_key_secret,
                    endpoint: uploadOss.sts.endpoint_internal,
                    stsToken: uploadOss.sts.security_token,
                    secure: true,
                });

                // oss 上传
                client
                    .multipartUpload(uploadOss.object_name, inputFile)
                    .then((res) => {
                        this.upLoadFiles.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.filename,
                            default: uploadOss.default,
                        });
                        this.arrMedia.push({
                            type: inputFile.type.split("/")[0],
                            url: uploadOss.url,
                            default: uploadOss.default,
                        });
                        console.log(this.arrMedia)
                    });
            });
        },

        choiceImg() {
            this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
        },
        // 关闭弹窗触发的函数
        handleClose() {
            this.stopListen();
        },
        // 判断用户目前是否在试听录音
        stopListen() {
            if (this.AuditionStatus == "正在试听") {
                wx.stopVoice({
                    localId: this.localId, // 需要停止的音频的本地ID，由stopRecord接口获得
                });
            }
            this.BshowToast = false;
            this.AuditionStatus = "试听录音";
        },
        // 点击重新录制触发的函数
        recordAgin() {
            this.stopListen();
            this.clickRecord();
        },
        // 点击试听触发的函数
        Audition() {
            if (this.AuditionStatus != "正在试听") {
                this.AuditionStatus = "正在试听";
                wx.playVoice({
                    localId: this.localId, // 需要播放的音频的本地ID，由stopRecord接口获得
                });
            } else {
                this.AuditionStatus = "已暂停";
                wx.pauseVoice({
                    localId: this.localId, // 需要暂停的音频的本地ID，由stopRecord接口获得
                });
            }
        },
        // 上传已录制语音
        updateVoice() {
            wx.uploadVoice({
                localId: this.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                //可以在success回调里把id传给自己的服务器后台，然后走微信服务器里下载
                success: (result) => {
                    // serverId = res.serverId; // 返回音频的服务器端ID
                    // alert('上传成功')
                    // alert(result.serverId);

                    //把录音在微信服务器上的id（res.serverId）发送到自己的服务器供下载。
                    // Sendserive_id({service_id:result.serverId}).then(result2 => {console.log(result2,'这个是结果2');})
                    // this.$store.dispatch("finish/SendId", {
                    //     service_id: result.serverId,
                    // });

                    sendSeriveId({ service_id:result.serverId }).then(res => {
                        let result = res.result;
                        this.sVoiceUrl = result.local_file
                        this.discussAdd(this.sVoiceUrl)
                    })
                },
            });
        },
        // 点亮星星
        lightStar(i, i2) {
            // 先全置否再重新赋值
            if (this.currentType == 1) {
                for (let j = 0; j < 5; j++) {
                    if (j <= i2) {
                        this.evaStarList[i].star[j] = true;
                    } else {
                        this.evaStarList[i].star[j] = false;
                    }
                }
                this.$forceUpdate();
            }
        },
        /**
         * 点击录音
         */
        clickRecord() {
            if (this.status === "close") {
                this.status = "start";
                wx.startRecord({
                    success: () => {
                        //alert("录音中");
                    },
                    cancel: () => {
                        //alert("不允许");
                    },
                    fail: (res) => {
                        alert(JSON.stringify(res));
                    },
                })
            } else if (this.status === "start") {
                this.status = "close";
                wx.stopRecord({
                    success: (res) => {
                        this.localId = res.localId;
                        this.BshowToast = true;
                        console.log(res);
                    },
                    fail: (res) => {
                        alert(JSON.stringify(res));
                    },
                });
            }
        },
        //根据数字转换成数组
        getStar(val) {
            let star = [];
            for (let i = 0; i < 5; i++) {
                if (i < val) {
                    star.push(true);
                } else {
                    star.push(false);
                }
            }
            return star;
        },
        //找出数组ture数量转换成数字
        getRank(arr) {
            let count = 0;
            arr.forEach((item) => {
                if (item == true) count++;
            });

            return count;
        },
        submit() {
            if (!this.isAgree) {
                this.bTipsRead = !this.bTipsRead;
                return;
            }
            // 上传语音录入的方法
            if (this.localId) {
                this.updateVoice();
            } else {
                this.discussAdd("");
            }
        },
        discussAdd(val) {
            let data = {
                type: 1,
                content: this.sContent,
                contract_id: this.contract_id,
                project_uuid: this.sProjectUuid,
                company_id: this.company_id ? this.company_id : 1,
                voice: val,
            };
            this.evaStarList.forEach((item, index) => {
                switch (index) {
                    case 0:
                        data.sale_score = this.getRank(item.star);
                        break;
                    case 1:
                        data.sign_score = this.getRank(item.star);
                        break;
                    case 2:
                        data.work_score = this.getRank(item.star);
                        break;
                    case 3:
                        data.delivery_score = this.getRank(item.star);
                        break;
                    case 4:
                        data.service_score = this.getRank(item.star);
                        break;
                }
            });
            if (data.sale_score == 0 || data.sign_score == 0 || data.work_score == 0 || data.delivery_score == 0 || data.service_score == 0) {
                alert("请先评分");
                return;
            }
            if (data.sale_score <= 3 && this.sContent.length <= 0) {
                    alert("3星及3星一下必须填写文字");
                return;
                }
                if (data.sign_score <= 3 && this.sContent.length <= 0) {
                    alert("3星及3星一下必须填写文字");
                return;
                }
                if (data.work_score <= 3 && this.sContent.length <= 0) {
                    alert("3星及3星一下必须填写文字");
                return;
                }
                if (data.delivery_score <= 3 && this.sContent.length <= 0) {
                    alert("3星及3星一下必须填写文字");
                return;
                }
                if (data.service_score <= 3 && this.sContent.length <= 0) {
                    alert("3星及3星一下必须填写文字");
                return;
                }
            console.log(data);
            net.discussAdd(data).then((res) => {
                this.$router.go(-1);
            });
        },
        //添加追加评价
        reSubmit() {
            //if (this.topic_id && this.company_id && this.contract_id) {
            let data = {
                content: this.addContent,
                pic: JSON.stringify(this.upLoadFiles), //oss返回的图片或视频链接
                contract_id: this.contract_id,
                company_id: this.company_id ? this.company_id : 1,
                //topic_id: this.topic_id,
                project_uuid: this.sProjectUuid,
            };
            net.reSubmit(data).then((res) => {
                this.$toast("添加成功")
                this.$router.go(-1);
            });

        },
        playVideo(url) {
            console.log(url);
            this.isVideoShow = true;
            this.sVideoPath = url;
        },
        handleImagePreview(arrList, index) {
            if (arrList[index].type === "image") {
                let arrImage = []
                //let data = JSON.parse(JSON.stringify(arrList))
                arrList.forEach(item => {
                    //过滤video
                    if (item.type === "image") {
                        if (item.pic) {
                            arrImage.push(item.pic)
                        } else if (item.url) {
                            arrImage.push(item.url)
                        }
                    }
                })
                let str = ""
                if (arrList[index].pic) {
                    str = arrList[index].pic
                } else if (arrList[index].url) {
                    str = arrList[index].url
                }
                //arrImage.splice(index, 1)
                //arrImage.splice(0, 0, str)
                ImagePreview(arrImage, index);
            }
        },
        audioClick() {
            const audio = this.$refs.audioRef;
            audio.paused ? audio.play() : audio.pause();
            // if (audio.paused) {
            //     // console.log("语音动态关");
            //     this.isAudio = false
            // } else {
            //     // console.log("语音动态开");
            //     this.isAudio = true
            // }
        }
    },
};
</script>

<style lang="scss" scoped>
.tips_read{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.747);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: identifier 0.8s forwards;
    .tips_read_content{
        width: 600px;
        background: #fff;
        padding: 20px 40px;
        box-sizing: border-box;
        font-size: 34px;
        text-align: justify;
        border-radius: 10px;
        .text_read{
            padding: 20px 0 ;
            box-sizing: border-box;
            border-bottom: 1px solid rgb(148, 204, 250);
        }
        .read_btn{
            width: 100px;
            height: 60px;
            background: $deepGreen;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 28px;
            margin: 20px auto 0;
        }
    }
}
@keyframes identifier {
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}
.content-wrap {
    min-height: 100vh;
    background: $commonBgColor;

    /*顶部图片*/
    .top-img {
        width: 100%;
        height: 366px;
    }

    /*card*/
    .card {
        width: 93.6%;
        margin: 28px auto 0;
        background: #fff;
        border-radius: $commonRadius;
        padding: 24px;
        .title {
            width: calc(100% + 48px);
            margin-left: -24px;
            margin-top: -24px;
            margin-bottom: 32px;
            height: 72px;
            line-height: 72px;
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            background: #318544;
            border-radius: 12px 12px 0px 0px;
        }
        /*验收文字*/
        .finish-con {
            font-size: $baseSize;
            font-weight: 400;
            color: $commonText;
            line-height: 40px;
            text-indent: 30px;
            padding: 8px 0 28px;
            border-bottom: 2px dashed #f1f1f1;
            letter-spacing: 0;
            word-spacing: 0;
        }

        /*验收按钮*/
        .finish-btn-wrap {
            padding-top: 22px;
            .finish-btn {
                width: 32px;
                height: 32px;
            }

            .finish-btn-text {
                font-size: $baseSize;
                font-weight: 400;
                color: $deepGreen;
                line-height: 20px;
                margin-left: 12px;
            }
        }

        /*标题*/
        .card-title {
            .card-title-block {
                width: 6px;
                height: 32px;
                background: $deepGreen;
                margin-right: 12px;
            }

            .card-title-text {
                font-size: $bigSize;
                font-weight: 500;
                color: $deepGreen;
                line-height: 44px;
                // white-space: nowrap;
            }
        }

        /*评星*/
        .star-wrap {
            width: 100%;
            margin: 32px 0 36px;

            .star-item {
                margin-bottom: 28px;

                &:last-child {
                    margin-bottom: 0;
                }

                .star-item-text {
                    font-size: $baseSize;
                    font-weight: 400;
                    color: $commonText;
                    line-height: 40px;
                    margin-right: 40px;
                }

                .star {
                    width: 32px;
                    height: 32px;
                    margin-right: 32px;

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        /*建议输入*/
        .advice-text {
            width: 100%;
            height: 248px;
            padding: 24px;
            background: #f7f7f7;
            border-radius: $commonRadius;
            resize: none;
        }
        // 查看留言
        .content {
            width: 654px;
            height: 216px;
            border-radius: 8px;
            border: 2px solid #e0e0e0;
            padding: 20px 24px;
            font-size: 28px;
            font-weight: 400;
            color: #858585;
            line-height: 40px;
        }
        /*录制按钮*/
        .recording-btn {
            width: 470px;
            height: 80px;
            margin: 24px auto 16px;
            background: #649559;
            border-radius: 40px;

            img {
                width: 32px;
                height: 32px;
                margin-right: 12px;
            }

            .audio-ref {
                position: absolute;
                z-index: -1;
            }

            font-size: $baseSize;
            font-weight: 400;
            color: #ffffff;
            line-height: 80px;
        }
        // 竣工评价和追加评价
        .addContent {
            margin-top: 48px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #444444;
            line-height: 40px;
            div:nth-child(1) {
                padding-bottom: 10px;
            }
            div:nth-child(2) {
                padding-bottom: 16px;
            }
            .imgbox {
                display: flex;
                margin-bottom: 40px;
                .img {
                    width: 144px;
                    height: 144px;
                    background: #eeeeee;
                    border-radius: 8px;
                    margin-right: 20px;
                    // &:last-child {
                    //     //margin-right: 0;
                    // }
                    object-fit: cover;
                }
            }
        }
        .addContent2 {
            width: 100%;
            margin-top: 60px;
            div:nth-child(1) {
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #444444;
                line-height: 40px;
                margin-bottom: 24px;
            }
            .input {
                width: 100% !important;
                padding: 24px;
                background: #f7f7f7;
                border-radius: 12px;
                width: 232px;
                font-size: 28px;
                font-weight: 400;
                color: #858585;
                line-height: 40px;
                margin-bottom: 28px;
            }
            .imgbox {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                margin-bottom: 40px;

                .img {
                    width: 144px;
                    height: 144px;
                    background: #eeeeee;
                    border-radius: 8px;
                    margin: 10px;
                    object-fit: cover;
                }

                .img-div {
                    width: 160px;
                    height: 160px;
                    position: relative;
                }
            }
            .addContentBtn {
                width: 186px;
                height: 68px;
                margin: 0 auto;
                // padding: 16px 44px;
                text-align: center;
                line-height: 69px;
                border-radius: 43px;
                border: 2px solid #898989;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #444444;
                margin-bottom: 74px;
            }
        }
    }

    .sub-card {
        padding-top: 28px;
    }

    /*button*/
    .sub-btn {
        width: 93.6%;
        height: 100px;
        background: $userBgGradient;
        border-radius: $commonRadius;
        margin: 40px auto 94px;

        font-size: $bigSize;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 100px;
    }
}

/*通用样式*/
.flc {
    display: flex;
    align-items: center;
    justify-content: center;
}

.fls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

::-webkit-input-placeholder {
    font-size: 28px;
    color: #858585;
}
.img-box {
    width: 131px;
    height: 131px;
}
.delete-image {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 0;
    right: 0;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    video {
        width: 100%;
    }
}
.pop {
    background-color: transparent;
}
</style>
